var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMinimize = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#F2F4F8",
  rx: 4
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#0C9BAB",
  clipPath: "url(#minimize_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.625 10.5h6.75c.623 0 1.125-.502 1.125-1.125v-6.75a1.127 1.127 0 0 0-1.922-.797L6.703 3.703 3.267.267a.905.905 0 0 0-1.284 0L.267 1.983a.905.905 0 0 0 0 1.284l3.436 3.436-1.875 1.875a1.127 1.127 0 0 0 .797 1.922Zm18.75 3h-6.75c-.623 0-1.125.502-1.125 1.125v6.75a1.127 1.127 0 0 0 1.922.797l1.875-1.875 3.44 3.44a.908.908 0 0 0 1.285 0l1.72-1.72a.909.909 0 0 0 0-1.284l-3.445-3.436 1.875-1.875a1.127 1.127 0 0 0-.797-1.922Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.375 10.5h-6.75A1.122 1.122 0 0 1 13.5 9.375v-6.75a1.127 1.127 0 0 1 1.922-.797l1.875 1.875L20.733.267a.905.905 0 0 1 1.284 0l1.72 1.72a.901.901 0 0 1-.004 1.28l-3.436 3.436 1.875 1.875a1.127 1.127 0 0 1-.797 1.922Zm-18.75 3h6.75c.623 0 1.125.502 1.125 1.125v6.75a1.127 1.127 0 0 1-1.922.797l-1.875-1.875-3.436 3.436a.905.905 0 0 1-1.284 0L.267 22.017a.905.905 0 0 1 0-1.284l3.436-3.436-1.875-1.875a1.127 1.127 0 0 1 .797-1.922Z",
  opacity: 0.4
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "minimize_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgMinimize;